<div class="modal-header bg-light">
    <h3 class="modal-title" id="modal-title">{{ AiLabels.title }}</h3>
    <div class="spriteBtns btn-margin-top">
        <button type="button" aria-label="Close" title="Close" (click)="closepopup()">
            <svg class="icon">
                <use [attr.xlink:href]="srcPath.closeIcon"></use>
            </svg>
        </button>
    </div>
</div>

<form>
    <div class="modal-body px-4 bg-light">

        <!-- TOP SECTION: AI Configuration Card -->
        <div class="card border-0 shadow-sm mb-4">
            <div class="card-header bg-white border-bottom-0 pt-3 pb-0">
                <h4 class="mb-1">{{ AiLabels.cards.settings }}</h4>
            </div>
            <div class="card-body">
                <div class="row g-3 p-2">
                    <div class="col-md-2" style="overflow: visible;">
                        <label class="form-label fw-medium">{{ AiLabels.fields.model }} <span>*</span></label>
                        <input type="text" class="form-control" [(ngModel)]="aiConfig().model" name="aiModel"
                            placeholder="e.g., gpt-4o">
                    </div>
                    <div class="col-md-4" style="overflow: visible;">
                        <label class="form-label fw-medium">{{ AiLabels.fields.endpointUrl }} <span>*</span></label>
                        <input type="url" class="form-control" [(ngModel)]="aiConfig().endpointUrl" name="aiUrl"
                            placeholder="https://api.openai.com/v1/chat/completions">
                    </div>
                    <div class="col-md-4" style="overflow: visible;">
                        <label class="form-label fw-medium">{{ AiLabels.fields.apiKey }} <span>*</span></label>
                        <input type="password" class="form-control" [(ngModel)]="aiConfig().apiKey" name="apiKey"
                            placeholder="sk-...">
                    </div>
                    <div class="col-md-2 mt-5" style="overflow: visible;">
                        <button type="button" class="btn commonBtn blueBtn" (click)="saveAiConfig()">Save Settings</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- BOTTOM SECTION: Prompt Templates Card -->
        <div class="card border-0 shadow-sm">
            <div class="card-header d-flex justify-content-between bg-white border-bottom-0 pt-3 pb-0">
                <h4 class="mb-0">{{ AiLabels.cards.prompts }}</h4>
                <div class="grdRwStyle spriteBtns">
                    <button type="button" class="back08" title="Add Prompt" (click)="openEditModal()">
                        <svg class="icon">
                            <use [attr.xlink:href]="srcPath.addIcon"></use>
                        </svg>
                    </button>
                </div>
            </div>
            <div class="card-body p-0 mt-3">
                <div class="table-responsive p-2">
                    <app-primeng-grid class="promptTable" [columnConfig]="columnDefPrimeNG" [data]="prompts()" [gridConfig]="gridConfigPrimeNG">

                        <ng-template primengTemplate="statusTemplate" let-row>
                            <div class="form-check form-switch fs-5 mb-0 d-flex justify-content-center">
                                <input class="form-check-input cursor-pointer" type="checkbox" role="switch" [checked]="row.enabled" (change)="toggleStatus(row)">
                            </div>
                        </ng-template>

                        <ng-template primengTemplate="buttonRenderer" let-row let-col="col" let-rowIndex="rowIndex">
                            <app-button-renderer [params]="buildParams(row,col,rowIndex)">
                            </app-button-renderer>
                        </ng-template>
                    </app-primeng-grid>
                </div>
            </div>
        </div>

    </div>
</form>

<!-- Secondary Modal: Edit Prompt Config -->
<div class="modal fade" bsModal #editPromptModal="bs-modal" tabindex="-1" aria-labelledby="editModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content shadow">
            <div class="columnHeader" style="margin: 0 !important;">
                <h3 class="modal-title" id="editModalLabel">{{ AiLabels.prompt_modal.title }}</h3>
                <div class="spriteBtns">
                    <!-- Call save function -->
                    <button type="button" title="Save" (click)="savePromptEdit()">
                        <svg>
                            <use [attr.xlink:href]="srcPath.saveIcon"></use>
                        </svg>
                    </button>
                    <!-- Call close function -->
                    <button type="button" title="Close" (click)="closeEditModal()">
                        <svg>
                            <use [attr.xlink:href]="srcPath.closeIcon"></use>
                        </svg>
                    </button>
                </div>
            </div>
            <div class="modal-body">
                <div class="mb-3">
                    <label class="form-label fw-medium">{{ AiLabels.prompt_modal.purpose }} <span>*</span></label>
                    <input type="text" class="form-control" [placeholder]="AiLabels.prompt_modal.purpose_placeholder"
                        [(ngModel)]="activeEditItem().purpose" name="editPurpose">
                </div>
                <div class="mb-3">
                    <label class="form-label fw-medium">{{ AiLabels.prompt_modal.prompt }} <span>*</span></label>
                    <textarea class="form-control font-monospace" rows="15" [placeholder]="AiLabels.prompt_modal.prompt_placeholder"
                        [(ngModel)]="activeEditItem().promptText" name="editPromptText"></textarea>
                </div>
            </div>
        </div>
    </div>
</div>